import { get, patch, post, del, postForm, postLoginApi, put} from "./api";
import * as url from "./url";

//dashboard
export const getDashboard = () => get(url.DASHBOARD);

// Authentication
export const postLogin = (data) => post(url.LOGIN, data);
export const getMe = () => get(url.ME);
export const postLogout = () => post(url.LOGOUT);

//Rol
export const postRolCreate = (data) => post(url.ROL, data);
export const getRolList = () => get(url.ROL);
export const getRolRead = (id) => get(`${url.ROL}${id}/`);
export const getRolFilter = (changeUrl) =>
get(`${url.ROL}${changeUrl.changeUrl}`);
export const getRolFullList = () => get(url.ROL_FULLLIST);
export const patchRolUpdate = (id, data) =>
  patch(`${url.ROL}${id.id}/`, data);
export const deleteRol = (id) => del(`${url.ROL}${id}/`);
export const postPermissionToGroup = (data) => post(url.PERMISSION_GROUP, data);


//USER
export const postUserCreate = (data) => post(url.USER, data);
export const putUpdatePassword = (id, data) => put(`${url.USER}${id.id}/update_password/`,data);
export const getUserList = () => get(url.USER);
export const getUserRead = (id) => get(`${url.USER}${id}/`);
export const getUserFilter = (changeUrl) =>
get(`${url.USER}${changeUrl.changeUrl}`);
export const getUserFullList = () => get(url.USER_FULLLIST);
export const patchUserUpdate = (id, data) =>
  patch(`${url.USER}${id.id}/`, data);
export const deleteUser = (id) => del(`${url.USER}${id}/`);
export const getPermission = () => get(url.PERMISSION);
export const postPermissionToUser = (data) => post(url.PERMISSION_USER, data);
export const patchPermissionToUser = (id, data) => patch(`${url.USER}${id}/add_permissions_to_user/`, data);



//ACCOUNT
export const postAccountCreate = (data) => post(url.ACCOUNT, data);
export const getAccountList = () => get(url.ACCOUNT);
export const getAccountRead = (id) => get(`${url.ACCOUNT}${id}/`);
export const getAccountFilter = (changeUrl) =>
get(`${url.ACCOUNT}${changeUrl.changeUrl}`);
export const getAccountFullList = () => get(url.ACCOUNT_FULLLIST);
export const patchAccountUpdate = (id, data) =>
  patch(`${url.ACCOUNT}${id.id}/`, data);

  //CAMPAIGN
export const postCampaignCreate = (data) => post(url.CAMPAIGN, data);
export const getCampaignList = () => get(url.CAMPAIGN);
export const getCampaignRead = (id) => get(`${url.CAMPAIGN}${id}/`);
export const getCampaignFilter = (changeUrl) =>
get(`${url.CAMPAIGN}${changeUrl.changeUrl}`);
export const getCampaignFullList = () => get(url.CAMPAIGN_FULLLIST);
export const patchCampaignUpdate = (id, data) =>
  patch(`${url.CAMPAIGN}${id.id}/`, data);

  //LENGS
export const postLengsCreate = (data) => post(url.LENGS, data);
export const getLengsList = () => get(url.LENGS);
export const getLengsRead = (id) => get(`${url.LENGS}${id}/`);
export const getLengsFilter = (changeUrl) =>
get(`${url.LENGS}${changeUrl.changeUrl}`);
export const getLengsFullList = () => get(url.LENGS_FULLLIST);
export const patchLengsUpdate = (id, data) =>
  patch(`${url.LENGS}${id.id}/`, data);

//CONTACTS
export const postContactsCreate = (data) => post(url.CONTACTS, data);
export const postContactsCreateSinLogin = (data) => postLoginApi(url.CONTACTS, data);
export const getContactsList = () => get(url.CONTACTS);
export const getContactsRead = (id) => get(`${url.CONTACTS}${id}/`);
export const getContactsFilter = (changeUrl) =>
get(`${url.CONTACTS}${changeUrl.changeUrl}`);
export const getContactsFilterAsync = (changeUrl) =>
get(`${url.CONTACTS}${changeUrl}`);
export const getContactsFullList = () => get(url.CONTACTS_FULLLIST);
export const patchContactsUpdate = (id, data) =>
  patch(`${url.CONTACTS}${id.id}/`, data);
export const deleteContacts = (id) => del(`${url.CONTACTS}${id}/`);
export const getAgent = () => get(url.CONTACTS_AGENT);


//CONTACT_DATA
export const postContactsDataCreate = (data) => post(url.CONTACTS_DATA, data);
export const getContactsDataList = () => get(url.CONTACTS_DATA);
export const getContactsDataRead = (id) => get(`${url.CONTACTS_DATA}${id}/`);
export const getContactsDataFilter = (changeUrl) =>
get(`${url.CONTACTS_DATA}${changeUrl.changeUrl}`);
export const getContactsDataFullList = () => get(url.CONTACTS_DATA_FULLLIST);
export const patchContactsDataUpdate = (id, data) =>
  patch(`${url.CONTACTS_DATA}${id.id}/`, data);
export const deleteContactsData = (id) => del(`${url.CONTACTS_DATA}${id}/`);
export const getContactsDataPhone = (id) => get(`${url.CONTACTS_DATA}get_datos_telefono/?contact=${id}`);
export const getContactsDataMail = (id) => get(`${url.CONTACTS_DATA}get_datos_email/?contact=${id}`);
export const getContactsDataAddress = (id) => get(`${url.CONTACTS_DATA}get_datos_direccion/?contact=${id}`);

//CONTACTS_DOMCUMENT
export const postContactsDocumentCreate = (data) => post(url.CONTACTS_DOCUMENT, data);
export const getContactsDocumentList = () => get(url.CONTACTS_DOCUMENT);
export const getContactsDocument = (id) => get(`${url.CONTACTS_DOCUMENT}get_document_contact/?contact=${id}`);
export const getContactsDocumentFullList = () => get(url.CONTACTS_DOCUMENT_FULLLIST);
export const getContactsDocumentRead = (id) => get(`${url.CONTACTS_DOCUMENT}${id}/`);
export const getContactsDocumentFilter = (changeUrl) =>
get(`${url.CONTACTS_DOCUMENT}${changeUrl}`);
export const patchContactsDocumentUpdate = (id, data) =>
  patch(`${url.CONTACTS_DOCUMENT}${id.id}/`, data);
export const deleteContactsDocument = (id) => del(`${url.CONTACTS_DOCUMENT}${id}/`);


//Casos

export const postCasosCreate = (data) => post(url.CASOS, data);
export const postFormCasosCreate = (data) => postForm(url.CASOS, data);
export const getCasosList = () => get(url.CASOS);
export const getCasosLista = () => get(url.CASOS_FULLLIST);
export const getCasosFullList = () => get(url.CASOS_FULLLIST);
export const getCasosRead = (id) => get(`${url.CASOS}${id}`);

export const getCasosFilter = (changeUrl) =>get(`${url.CASOS}${changeUrl.changeUrl}`);


export const patchCasosUpdate = (id, data) => patch(`${url.CASOS}${id}/`, data);


//CasosDetalles

export const postCasosDetallesCreate = (data) => post(url.CASOSDETALLES, data);
export const getCasosDetallesList = () => get(url.CASOSDETALLES);
export const getCasosDetallesLista = () => get(url.CASOSDETALLES_FULLLIST);
export const getCasosDetallesRead = (id) => get(`${url.CASOSDETALLES}${id}`);
export const getCasosDetallesFilter = (changeUrl) =>
get(`${url.CASOSDETALLES}${changeUrl.changeUrl}`);


export const patchCasosDetallesUpdate = (id, data) => patch(`${url.CASOSDETALLES}${id}/`, data);


//GRUPOTECNICO

export const postGrupoTecnicoCreate = (data) => post(url.GRUPOTECNICO, data);
export const getGrupoTecnicoList = () => get(url.GRUPOTECNICO);
export const getGrupoTecnicoLista = () => get(url.GRUPOTECNICO);
export const getGrupoTecnicoFullList = () => get(url.GRUPOTECNICO_FULLLIST);
export const getGrupoTecnicoRead = (id) => get(`${url.GRUPOTECNICO}${id}`);
export const getGrupoTecnicoFilter = (changeUrl) =>
get(`${url.GRUPOTECNICO}${changeUrl.changeUrl}`);

export const deleteGrupoTecnico = (id) => del(`${url.GRUPOTECNICO}${id}/`);
export const patchGrupoTecnicoUpdate = (id, data) => patch(`${url.GRUPOTECNICO}${id}/`, data);


//Informes

export const postInformesCreate = (data) => post(url.INFORMES, data);
export const getInformesList = () => get(url.INFORMES);
export const getInformesRead = (id) => get(`${url.INFORMES}${id}/`);
export const getInformesFilter = (changeUrl) =>
get(`${url.INFORMES}${changeUrl.changeUrl}`);
export const getInformesFilterAsync = (changeUrl) =>
get(`${url.INFORMESPORCASO}${changeUrl}`);
export const getInformesPorCasoFilter = (changeUrl) =>
get(`${url.INFORMESPORCASO}${changeUrl}`);
export const getInformesFullList = () => get(url.INFORMES_FULLLIST);
export const patchInformesUpdate = (id, data) =>
  patch(`${url.INFORMES}${id.id}/`, data);


//InformeImage

export const postInformeImageCreate = (data) => post(url.INFORMEIMAGE, data);
export const getInformeImageList = () => get(url.INFORMEIMAGE);
export const getInformeImageRead = (id) => get(`${url.INFORMEIMAGE}${id}/`);
export const getInformeImageFilter = (changeUrl) =>
get(`${url.INFORMEIMAGE}${changeUrl.changeUrl}`);
export const getInformeImageFullList = () => get(url.INFORMES_FULLLIST);
export const patchInformeImageUpdate = (id, data) =>
  patch(`${url.INFORMEIMAGE}${id.id}/`, data);
  export const deleteInformeImage = (id) => del(`${url.INFORMEIMAGE}${id}/`);

//LEADS

export const postLeadsCreate = (data) => post(url.LEADS, data);
export const getLeadsList = () => get(url.LEADS);
export const getLeadsLista = () => get(url.LEADS_FULLLIST);
export const getLeadsRead = (id) => get(`${url.LEADS}${id}`);
export const getLeadsFilter = (changeUrl) =>
get(`${url.LEADS}${changeUrl.changeUrl}`);

export const deleteLeads = (id) => del(`${url.LEADS}${id}/`);
export const patchLeadsUpdate = (id, data) => patch(`${url.LEADS}${id}/`, data);


//AGENDA
export const postAgendaCreate = (data) => post(url.AGENDA, data);
export const getAgendaList = () => get(url.AGENDA);
export const getAgendaRead = (id) => get(`${url.AGENDA}${id}/`);
export const getAgendaFilter = (changeUrl) =>
get(`${url.AGENDA}${changeUrl.changeUrl}`);
export const getAgendaFullList = () => get(url.AGENDA_FULLLIST);
export const patchAgendaUpdate = (id, data) =>
  patch(`${url.AGENDA}${id.id}/`, data);
export const deleteAgenda = (id) => del(`${url.AGENDA}${id}/`);

//COMPRAS
export const postComprasCreate = (data) => post(url.COMPRAS, data);
export const getComprasList = () => get(url.COMPRAS);
export const getComprasRead = (id) => get(`${url.COMPRAS}${id}/`);
export const getComprasFilter = (changeUrl) =>
get(`${url.COMPRAS}${changeUrl.changeUrl}`);
export const getComprasFullList = () => get(url.COMPRAS_FULLLIST);
export const patchComprasUpdate = (id, data) =>
  patch(`${url.COMPRAS}${id}/`, data);
export const deleteCompras = (id) => del(`${url.COMPRAS}${id}/`);

// export const patchCasosUpdate = (id, data) => patch(`${url.CASOS}${id}/`, data);